module.exports = __webpack_public_path__ + "static/media/pay-top-success5.c696fcfe.png";